import React, { ReactElement, useState } from 'react';
import { Breadcrumbs, homeBreadcrumb, PageLoader } from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import { MojeUlohyList } from '../../../module/LegislativnyMaterial/Ulohy';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import { pouzivalHasLegOrg } from '../../../function/permissions';
import { useUserContext } from '../../../context/UserContext';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../context/PracovnyKrokLegislativnyMaterialContext';
import SuccessMessages from '../../../module/SuccessMessages';

const MojeUlohyListPage = (): ReactElement => {
  const [pageStatus, setPageStatus] = useState<number>(null);
  const { pouzivatel } = useUserContext();
  const { loadingMaterial } = usePracovnyKrokLegislativnyMaterialContext();
  const classes: string = classNames(
    'moje-ulohy-list-page',
    loadingMaterial && 'slovlex-idsk-hidden',
  );

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        { to: routes.mojeUlohy, heading: 'Moje úlohy' },
      ]}
      />
      <GlobalErrors />
      <PageLoader loading={loadingMaterial} />
      <SecuredPage
        additionalCheck={pouzivalHasLegOrg(pouzivatel)}
        requestStatus={pageStatus}
      >
        <div className={classes}>
          <SuccessMessages />
          <PageHeadingWithBackButton heading="Moje úlohy" />
          <MojeUlohyList setPageStatus={setPageStatus} />
        </div>
      </SecuredPage>
    </Layout>
  );
};

export default MojeUlohyListPage;
